// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"230":"component---src-pages-index-jsx","256":"component---src-pages-404-jsx"}[chunkId] || chunkId) + "-" + {"230":"a81cd9446ee040669ce4","256":"3acae979144aeb11fa79","731":"351724554e66b8bd6831","843":"267fd5d5fe0dc273620d"}[chunkId] + ".js";
};